var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.row[ this.field.slug + '_filename' ])?_c('img',{attrs:{"src":_vm.src}}):_c('span',{staticClass:"no-photo"},[_c('span',{staticClass:"fa fa-image-polaroid"})])])}
var staticRenderFns = []

export { render, staticRenderFns }